import { Alert, Stack, Typography } from "@mui/material";
import ProgressCard from "./ProgressCard";

const ProgressTimeline = ({ reports = [] }) => {
  if (!reports.length) {
    return (
      <Alert severity="info" data-testid="progress-timeline-empty">
        هنوز گزارش پیشرفتی ثبت نشده است.
      </Alert>
    );
  }

  return (
    <Stack spacing={1.5} data-testid="progress-timeline">
      <Typography variant="subtitle1" fontWeight={700}>
        گزارش‌های ارسالی
      </Typography>
      {reports.map((report) => (
        <ProgressCard
          key={report.id}
          percentComplete={report.percentComplete}
          status={report.status}
          statusTitle={report.statusTitle}
          description={report.description}
          submittedAt={report.submittedAt}
          reviewComment={report.reviewComment}
          testId={`progress-card-${report.id}`}
        />
      ))}
    </Stack>
  );
};

export default ProgressTimeline;
